import React from 'react';
import { Link } from 'gatsby';
import LogoWide from '../../images/icons/DEUTSCH_LOGO_WIDE.svg';
import logoLive from '../../images/dla_faces_alive_03.gif';
import HamburgerMenu from './hamburgerMenu';

interface Props {
  opened: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const DesktopHeader: React.FC<Props> = ({ opened, setOpened }) => {
  return (
    <div className="hidden laptop-standard:flex items-center justify-center justify-between">
      <div className="h-15 w-15">
        <Link to="/" title="Navigate to Home">
          <img className="h-full w-full" src={logoLive} alt="Deutsh LA logo" />
        </Link>
      </div>
      <div className="h-6">
        <Link to="/" title="Navigate to Home">
          <LogoWide className="h-full" />
        </Link>
      </div>
      <div
        id="hamburguer-menu-desktop"
        className="pt-2 z-30"
        onClick={() => setOpened(!opened)}
        title="Open navigation Menu"
      >
        <HamburgerMenu open={opened} />
      </div>
    </div>
  );
};

export default DesktopHeader;
